import { render } from "./top-bar.vue?vue&type=template&id=5a962697&scoped=true"
import script from "./top-bar.vue?vue&type=script&lang=js"
export * from "./top-bar.vue?vue&type=script&lang=js"

import "./top-bar.vue?vue&type=style&index=0&id=5a962697&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a962697"]])

export default __exports__